import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { CommonResponse } from 'src/app/models/commomResponse';
import {
  teamListData,
  teamPayload
} from 'src/app/models/teamListData';
import { environment } from 'src/environments/environment';
import { teamListwithGeofenceResponse } from 'src/app/models/teamListwithGeofence';
import { driverData, teamDriverData } from 'src/app/models/driverData';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {
  constructor(private http: HttpClient) { }

  getTeamsById(id: string): Observable<teamListwithGeofenceResponse> {
    return this.http
      .get<{
        data: teamListwithGeofenceResponse;
      }>(`${environment.base_url}manageTeams/${id}`)
      .pipe(map(res => res.data));
  }

  addTeam(data: teamPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}addTeams`,
      data
    );
  }

  updateTeam(
    data: teamPayload,
    id: string | undefined
  ): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.base_url}editTeams/${id}`,
      data
    );
  }
  getTeamList(data: string): Observable<teamListData> {
    return this.http
      .get<{ data: teamListData }>(`${environment.base_url}manageTeams?${data}`)
      .pipe(map(res => res.data));
  }

  deleteTeam(id: string): Observable<number> {
    return this.http
      .delete<{
        statusCode: number;
      }>(`${environment.base_url}deleteTeams/${id}`)
      .pipe(map(res => res.statusCode));
  }

  getDriversByTeam(teamId: string): Observable<Array<teamDriverData>> {
    if (!teamId) {
      return new Observable(observer => {
        observer.next([]);
        observer.complete();
      });
    }
    
    return this.http
      .get<{ data: Array<teamDriverData> }>(`${environment.base_url}driversThroughTeam/${teamId}`)
      .pipe(map(res => res.data));
  }

  removeDriverFromTeam(teamId: string, driverId: string): Observable<number> {
    if (!teamId || !driverId) {
      return of(400); // Bad request
    }
    
    return this.http
      .delete<{
        statusCode: number;
      }>(`${environment.base_url}teams/${teamId}/drivers/${driverId}`)
      .pipe(map(res => res.statusCode));
  }
}
